import React, { useState } from "react";
import { Route } from "react-router-dom";
import Main from "routes/index";
import { ToastNotification } from "components/Notification/ToastNotification";
import { useReactPWAInstall } from "react-pwa-install";
// component
import Home from "views/home/Home";
import JobDetails from "views/job-details/JobDetails";
import JobListing from "views/job-listing/JobListing";
import Ilearn from "views/ilearn/Ilearn";
import IlearnDetails from "views/ilearn/ilearndetails/IlearnDetails";
import ITV from "views/ITV-details/ITV";
import ContactUs from "views/contactUs/ContactUs";
import KnowUsMore from "views/know-us-more/KnowUsMore";
import Profile from "views/profile/ProfileMain";
// end
// import Login from "./routes/login";
// import Auth from "layouts/Auth.js";
import Approutes from "./routes/approutes";
import ApplicantNavbar from "components/Navbars/ApplicantNavbar";
import ApplicantNavBeforeLogin from "components/Navbars/ApplicantNavBeforeLogin";
// import myLogo from "./logo70.png";
import Session from "react-session-api";
import store from "store.js";
import ErrorBoundary from "utility/errorboundry";

// import { css } from "@emotion/react";
// import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
// const override = css`
//   display: block;
//   margin: 0 auto;
//   border-color: red;
// `;

function CheckValidateRoute(props) {
  // let [loading, setLoading] = useState(true);
  // let [color, setColor] = useState("#336089");
  // class CheckValidateRoute extends React.Component {
  // render() {
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
  const handleClick = () => {
    pwaInstall({
      title: "Install ICICI App",
      logo: require("assets/img/fav_logo.png"),
      features: (
        <ul>
          <li>Save Device Space</li>
          <li>Faster Access</li>
          <li>Even cooler feature</li>
          <li>Works offline</li>
        </ul>
      ),
      description:
        "Hi progressive web app enable you to access ICICI careers pages more quicker than before.",
    })
      .then(() =>
        alert("App installed successfully or instructions for install shown")
      )
      .catch(() => alert("User opted out from installing"));
  };

  if (store.getState().Auth.user.USER_DETAILS_MG?store.getState().Auth.user.USER_DETAILS_MG.ApplicantId:false) {
    return (
      <div>
        {/* <ErrorBoundary> */}
        {/* <ApplicantNavbar /> */}
        <ApplicantNavBeforeLogin />
        <Approutes />
        {/* </ErrorBoundary> */}
      </div>
    );
  } else if (store.getState().Auth.user.USER_DETAILS_MG?!store.getState().Auth.user.USER_DETAILS_MG.ApplicantId:true) {
    return (
      <div>
        {/* <ApplicantNavbar /> */}
        {/* <ErrorBoundary> */}
        <ApplicantNavBeforeLogin />
        <Approutes />
        {/* </ErrorBoundary> */}
      </div>
    );
  }
}
// }
export default CheckValidateRoute;
